module.exports = __webpack_public_path__ + "static/media/jackpetraitis_resume.9b7dcfcc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resumes/finals/jackpetraitis_resume.pdf
// module id = 307
// module chunks = 0